import { render, staticRenderFns } from "./history_list.vue?vue&type=template&id=6a80a50f&lang=pug&"
import script from "./history_list.vue?vue&type=script&lang=js&"
export * from "./history_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports